import { NgModule } from '@angular/core';
import { ItemSwiperComponent } from './item-swiper.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ListingCardModule } from '../listing-card/listing-card.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ListingCardModule
  ],
  declarations: [
    ItemSwiperComponent
  ],
  exports: [
    ItemSwiperComponent
  ]
})
export class ItemSwiperModule { }
